;
globalThis["_sentryRewritesTunnelPath"] = "/sentry-tunnel";
globalThis["SENTRY_RELEASE"] = {
    "id": "aK83vcHgoyN6sSStFuyUd"
};
globalThis["_sentryBasePath"] = undefined;
globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";
import * as Sentry from "@sentry/nextjs";
const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
const sentryEnabled = "production" === "production" && environment === "prod";
function isBrowserTranslated() {
    return typeof document !== "undefined" && (document.documentElement.classList.contains("translated-ltr") || document.documentElement.classList.contains("translated-rtl"));
}
if (sentryEnabled && process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        environment,
        // Keep volume low for the Sentry free tier.
        tracesSampleRate: 0.05,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.1,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true
            })
        ],
        ignoreErrors: [
            "ResizeObserver loop limit exceeded",
            "ResizeObserver loop completed with undelivered notifications",
            "Text content does not match server-rendered HTML",
            "Hydration failed because the initial UI does not match",
            "There was an error while hydrating",
            "Hydration failed because the server rendered HTML didn't match the client",
            "Non-Error promise rejection captured",
            /^Script error\.$/,
            /^ChunkLoadError/,
            /^Loading chunk \d+ failed/,
            "The operation was aborted",
            "AbortError: Fetch is aborted",
            "NetworkError when attempting to fetch resource"
        ],
        beforeSend (event) {
            var _event_exception;
            if ((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) {
                for (const ex of event.exception.values){
                    var _ex_stacktrace;
                    if (ex.type === "RangeError" && ex.value === "Maximum call stack size exceeded" && isBrowserTranslated()) {
                        return null;
                    }
                    var _ex_stacktrace_frames;
                    const frames = (_ex_stacktrace_frames = (_ex_stacktrace = ex.stacktrace) === null || _ex_stacktrace === void 0 ? void 0 : _ex_stacktrace.frames) !== null && _ex_stacktrace_frames !== void 0 ? _ex_stacktrace_frames : [];
                    const fromExtension = frames.some((frame)=>{
                        var _frame_filename, _frame_filename1;
                        return ((_frame_filename = frame.filename) === null || _frame_filename === void 0 ? void 0 : _frame_filename.includes("chrome-extension://")) || ((_frame_filename1 = frame.filename) === null || _frame_filename1 === void 0 ? void 0 : _frame_filename1.includes("moz-extension://"));
                    });
                    if (fromExtension) return null;
                }
            }
            return event;
        }
    });
}
